import { isObligationBatchPreviewResponse, } from '@urbanik/api-contracts';
export class ObligationBatchPreviewApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        this.name = 'ObligationBatchPreviewApiError';
    }
}
export async function previewObligationBatch(base, input, signal) {
    let response;
    try {
        response = await fetch(`${base.replace(/\/$/, '')}/identity/collections/obligation-batch-preview`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify(input),
            ...(signal ? { signal } : {}),
        });
    }
    catch {
        throw new ObligationBatchPreviewApiError('unavailable', 'No pudimos conectar con el servidor.');
    }
    const body = await response.json().catch(() => null);
    if (!response.ok) {
        const message = typeof body === 'object' &&
            body !== null &&
            'message' in body &&
            typeof body.message === 'string'
            ? body.message
            : 'No pudimos calcular la vista previa.';
        throw new ObligationBatchPreviewApiError(response.status === 401
            ? 'unauthorized'
            : response.status === 403
                ? 'forbidden'
                : response.status === 400
                    ? 'invalid'
                    : 'unavailable', message);
    }
    if (!isObligationBatchPreviewResponse(body))
        throw new ObligationBatchPreviewApiError('invalid', 'La vista previa recibida no es válida.');
    return body;
}
